Bu sayfadaki puf noktalar:
1 - Bos
<template>
    <div>
        <Navbar />
        <Sepet :key="componentKey"/>
        <BottomNavMenu />
        <Footer />
    </div>
</template>

<script>
import Navbar from "@/components/Navbar"
import Sepet from "@/components/Sepet"
import BottomNavMenu from "@/components/BottomNavMenu"
import Footer from "@/components/Footer"
import {
    mapGetters
} from 'vuex'


export default {

    data() {
    return {
      componentKey: 0,
    };
  },
    metaInfo() {
        return{
            title: 'Sepet',
            // titleTemplate: '%s | My Awesome Webapp'
        }
    },
    components : {
        Navbar,
        Sepet,
        BottomNavMenu,
        Footer
    },
    methods:{

        forceRerender() {
         
      this.componentKey += 1;
    }


    },

    computed: {
        ...mapGetters(["isSepetChangedFromArama", ]), // wglobal.js-den image degeri alinir
      

    },
    

    watch: {
        

        isSepetChangedFromArama(val){

            console.log("changed")

            if(val)
            {

                this.forceRerender()

                this.$store.commit('addisSepetChangedFromArama', false)
            }
          

        }
    },

}
</script>

<style scoped>

</style>